import React from "react";
import "@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css";
import "@trp-beacon-ui-kit/foundation/fonts/fonts.css";
import "@trp-beacon-ui-kit/foundation/css/style.css";
import { Box } from "@mui/material";
import { RicBeaconModal, RicBeaconButton } from "../shared/BeaconRegister";
import { tRoweFormatted } from "../shared/Content";
import { showModal } from "../../Utils";
import { dispatchOverlayLoad } from "../shared/Analytics";

const ExistingFPSModal = ({ isRASUser, userInFPS }) => {
  const appName = isRASUser ? "Retirement Advisory" : "Planning";
  const handleEsc = event => {
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  React.useEffect(() => {
    if (isRASUser) {
      showModal("existing-planning-service");
      dispatchOverlayLoad("Retirement Advisory Service Referral");
    } else {
      showModal("existing-planning-service");
      dispatchOverlayLoad("Planning Service Referral");
    }
  }, [isRASUser, userInFPS]);

  return (
    <RicBeaconModal
      id="existing-planning-service"
      persist
      onKeyDown={event => handleEsc(event)}
    >
      <Box
        className="beacon-theme-modern-outlook"
        sx={{ padding: "32px 32px 16px 32px" }}
      >
        <Box
          id="existing-FPS-header"
          className="b-typography-serif--headline--300"
          pb="16px"
        >
          We noticed you are currently enrolled in the {tRoweFormatted}{" "}
          {appName} Service.
        </Box>
        <Box
          id="existing-FPS-content"
          className="b-typography-sans-serif--body-loose--100"
          pb="32px"
        >
          The {appName} Service gives you a more complete picture for retirement
          while considering your other financial goals. Plus, it offers advice
          delivered by a {tRoweFormatted} financial advisor. We suggest visiting
          your planning hub to see your current status in {appName} Service.
        </Box>
      </Box>
      <Box
        id="visit-button-container"
        sx={{
          padding: "0px 32px 32px 32px"
        }}
      >
        {isRASUser ? (
          <RicBeaconButton
            id="visit-ras-home-button"
            onClick={() => {
              window.location.replace("/usis/advice/ras-home/");
            }}
          >
            Visit Retirement Advisory Service Home
          </RicBeaconButton>
        ) : (
          <RicBeaconButton
            id="visit-planning-hub-button"
            onClick={() => {
              window.location.replace("/usis/advice/fps/");
            }}
          >
            Visit Planning Hub
          </RicBeaconButton>
        )}
      </Box>
    </RicBeaconModal>
  );
};

export default ExistingFPSModal;
